<template>
    <div v-if="!loadingPage">
        <div v-if="isAdminIdentityVerified" class="pb-2">
            <div class="d-flex justify-content-between align-items-center">
                <h3 class="mb-2 text-primary">ارسال گروهی پیامک</h3>
                <div class="mb-2">
                    <b-button @click="$router.push(`/sms-send-management`)" variant="primary" class="px-2">
                        <span>ثبت درخواست</span>
                    </b-button>
                </div>
            </div>

            <b-row>
                <b-col md="3" class="mt-25">
                    <b-form-group label="تاریخ شروع ثبت درخواست" label-for="fromId">
                        <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                            :value="parameters.from ? formatDate(parameters.from) : null" autocomplete="off"
                            name="fromId" />
                        <date-picker v-model="parameters.from" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-25">
                    <b-form-group label="تاریخ پایان ثبت درخواست" label-for="toId">
                        <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                            :value="parameters.to ? formatDate(parameters.to) : null" autocomplete="off" />
                        <date-picker v-model="parameters.to" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-25">
                    <b-form-group label="وضعیت درخواست" label-for="statusId">
                        <v-select v-model="parameters.status" :searchable="false" dir="rtl" :options="statusData"
                            :reduce="(value) => value.id" label="name" id="statusId" class="bg-white"
                            style="border-radius: 6px;" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-0 mt-md-2">
                    <b-button variant="info" @click="getSmsSchedules" :disabled="loading"
                        class="mt-25 d-flex justify-content-center w-100">
                        <span>جستجو</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>

            <b-card class="p-0 mt-2 mt-md-1" no-body>
                <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table v-if="requestList.length" responsive :items="requestList" :fields="fields" class="mb-0"
                        striped>
                        <template #cell(details)="data">
                            <b-spinner v-if="loadingbuttons[data.index]" variant="info" small></b-spinner>
                            <feather-icon v-else @click="showDetails(data.item.id, data.index)" size="20"
                                icon="InfoIcon" class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(totalMessagesCost)="data">
                            {{
                                data.item.totalMessagesCost ? data.item.totalMessagesCost.toLocaleString('fa-IR') : '-'
                            }}
                        </template>
                        <template #cell(successfulSentCount)="data">
                            {{
                                data.item.successfulSentCount ? data.item.successfulSentCount : '-'
                            }}
                        </template>
                        <template #cell(status)="data">
                            <b-badge :variant="requestStatusColor(data.item.status)" pill>
                                {{ requestStatus(data.item.status) }}
                            </b-badge>
                        </template>
                        <template #cell(createdAt)="data">
                            <div>
                                <span>
                                    {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                                </span>
                            </div>
                        </template>
                        <template #cell(dateTime)="data">
                            <div>
                                <span>
                                    {{ new Date(data.item.dateTime).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new Date(data.item.dateTime).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                                </span>
                            </div>
                        </template>
                    </b-table>
                    <div v-else class="text-center pt-5 pb-4">
                        موردی وجود ندارد
                    </div>
                </b-overlay>
            </b-card>
            <b-pagination align="center" @input="getSmsSchedules" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>

        <b-card v-else>
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal detail ------------------------------->
        <b-modal id="sms-schedules-detail" title="جزئیات" centered :hide-footer="true" title-class="font-weight-bolder"
            size="lg">
            <div>
                <b-card class="mt-1">
                    <h4 class="mb-0 text-info font-weight-bolder">جزئیات درخواست</h4>
                    <b-row>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">عنوان درخواست</h5>
                                    <h4 class="mb-0">{{ smsSchedulesDetails.title }}
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-info">
                                            <feather-icon size="20" icon="FileTextIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">زمان ثبت درخواست</h5>
                                    <h4 class="mb-0">
                                        <span>
                                            {{ new Date(smsSchedulesDetails.createdAt).toLocaleDateString('fa-IR') }}
                                        </span>
                                        <span> - </span>
                                        <span>
                                            {{ new
                                                Date(smsSchedulesDetails.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                                    2).join(":") }}
                                        </span>
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-info">
                                            <feather-icon size="20" icon="CalendarIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">زمان ارسال پیامک</h5>
                                    <h4 class="mb-0">
                                        <span>
                                            {{ new Date(smsSchedulesDetails.dateTime).toLocaleDateString('fa-IR') }}
                                        </span>
                                        <span> - </span>
                                        <span>
                                            {{ new
                                                Date(smsSchedulesDetails.dateTime).toLocaleTimeString('fa-IR').split(":").slice(0,
                                                    2).join(":") }}
                                        </span>
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-secondary">
                                            <feather-icon size="20" icon="CalendarIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">وضعیت درخواست</h5>
                                    <h4 class="mb-0">
                                        {{ requestStatus(smsSchedulesDetails.status) }}
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-secondary">
                                            <feather-icon size="20" icon="GridIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">تعداد مشتریان</h5>
                                    <h4 class="mb-0">
                                        {{ smsSchedulesDetails.customersCount }}
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-secondary">
                                            <feather-icon size="20" icon="UsersIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">هزینه کل پیامک ها</h5>
                                    <h4 class="mb-0">
                                        {{ smsSchedulesDetails.totalMessagesCost ?
                                            `${smsSchedulesDetails.totalMessagesCost.toLocaleString('fa-IR')} ریال` : '-' }}
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-secondary">
                                            <feather-icon size="20" icon="DollarSignIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card>
                    <h4 class="mb-1 text-info font-weight-bolder">متن پیامک</h4>
                    <b-form-textarea rows="4" no-resize dir="rtl" disabled
                        v-model="smsSchedulesDetails.message"></b-form-textarea>
                </b-card>
                <b-alert variant="info" show>
                    <p class="alert-body text-center">
                        لغو درخواست فقط تا زمانی ممکن است که وضعیت درخواست «در حال بررسی» باشد. پس از تأیید توسط تیم
                        پشتیبانی،
                        امکان لغو وجود ندارد. ویرایش نیز تنها در صورت رد شدن درخواست امکان‌پذیر است.
                    </p>
                </b-alert>
                <b-row class="pt-25">
                    <b-col md="6">
                        <b-button @click="$bvModal.show('cancel-request-sms')" class="w-100 mb-1" variant="danger"
                            :disabled="smsSchedulesDetails.status != 0">
                            لغو درخواست
                        </b-button>
                    </b-col>
                    <b-col md="6">
                        <b-button @click="manageRequestEditing" class="w-100 mb-1" variant="primary"
                            :disabled="smsSchedulesDetails.status != 2">
                            ویرایش
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <!-------------------------------------- modal cancel sms -------------------------------------->
        <b-modal id="edit-request-sms" :title="`ویرایش درخواست ${smsSchedulesDetails.title}`" centered
            :hide-footer="true" title-class="font-weight-bolder" size="md">
            <div class="p-1">
                <validation-observer ref="requestEditSMS">
                    <b-form @submit.prevent>
                        <b-form-group label="متن پیامک" label-for="messageId" class="text-center">
                            <validation-provider #default="{ errors }" name="متن پیامک" rules="required">
                                <b-form-textarea rows="4" no-resize autocomplete="off" dir="rtl"
                                    :class="errors.length > 0 ? 'border-danger' : null" id="messageId"
                                    v-model="form.message" name="message"></b-form-textarea>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-button type="submit" variant="primary" @click="requestEditSMS" :disabled="loadingButton"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>ویرایش</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

        <!-------------------------------------- modal cancel sms -------------------------------------->
        <b-modal id="cancel-request-sms" title="لغو درخواست" centered :hide-footer="true"
            title-class="font-weight-bolder" size="md">
            <div class="p-1">
                <h5 class="text-center text-danger mb-3 mt-1">
                    آیا از لغو این درخواست مطمئن هستید؟
                </h5>
                <div class="d-flex align-items-center">
                    <b-button @click="$bvModal.hide('cancel-request-sms')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button type="submit" variant="danger" @click="smsCancelRequest" :disabled="loadingButton"
                        class="w-50 d-flex align-items-center justify-content-center">
                        <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                        <span>لغو</span>
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BAlert, BTable, BBadge, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BFormFile, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BBadge,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BAlert,
        BFormFile,
        vSelect
    },
    computed: {
        requestStatus() {
            return (status) => {
                if (status == 0) {
                    return 'در حال بررسی'
                }
                if (status == 1) {
                    return 'تایید شده'
                }
                if (status == 2) {
                    return 'رد شده'
                }
                if (status == 3) {
                    return 'لغو شده'
                }
                if (status == 4) {
                    return 'ناموفق'
                }
            }
        },
        requestStatusColor() {
            return (status) => {
                if (status == 0) {
                    return 'light-primary'
                }
                if (status == 1) {
                    return 'light-success'
                }
                if (status == 2) {
                    return 'light-danger'
                }
                if (status == 3) {
                    return 'light-secondary'
                }
                if (status == 4) {
                    return 'light-secondary'
                }
            }
        },
    },
    data() {
        return {
            required,
            isAdminIdentityVerified: false,
            loadingButton: false,
            loadingPage: true,
            loading: false,
            loadingbuttons: [],
            currentDate: '',
            statusData: [
                { name: 'همه', id: null },
                { name: 'در حال بررسی', id: 0 },
                { name: 'تایید شده', id: 1 },
                { name: 'رد شده', id: 2 },
                { name: 'لغو شده', id: 3 },
                { name: 'ناموفق', id: 4 },
            ],
            smsSchedulesDetails: {},
            requestList: [],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                from: null,
                to: null,
                status: null,
            },
            fields: [
                {
                    key: 'title',
                    label: 'عنوان درخواست',
                },
                {
                    key: 'createdAt',
                    label: 'زمان ثبت درخواست',
                },
                {
                    key: 'dateTime',
                    label: 'زمان ارسال پیامک',
                },
                {
                    key: 'status',
                    label: 'وضعیت درخواست',
                },
                {
                    key: 'customersCount',
                    label: 'تعداد مشتریان',
                },
                {
                    key: 'successfulSentCount',
                    label: 'تعداد موفق',
                },
                {
                    key: 'totalMessagesCost',
                    label: 'هزینه کل پیامک ها (ریال)',
                },
                {
                    key: 'details',
                    label: 'جزئیات',
                },
            ],
            form: {
                message: null,
                dateTime: null,
            },
        }
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        requestEditSMS() {
            this.$refs.requestEditSMS.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.requestEditSMS(this.storeId, this.smsSchedulesDetails.id, this.form).then(({ data }) => {
                        this.$refs.requestEditSMS.reset();
                        this.$notif({ type: 'success' });
                        this.$bvModal.hide('edit-request-sms')
                        this.getSmsSchedules()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        manageRequestEditing() {
            this.form.dateTime = this.smsSchedulesDetails.dateTime
            this.form.message = this.smsSchedulesDetails.message
            this.$bvModal.hide('sms-schedules-detail')
            this.$bvModal.show('edit-request-sms')
        },
        showDetails(id, index) {
            this.$set(this.loadingbuttons, index, true);
            storeService.getSmsSchedulesById(this.storeId, id).then(({ data }) => {
                this.smsSchedulesDetails = data
                this.$set(this.loadingbuttons, index, false);
                this.$bvModal.show('sms-schedules-detail')
            })
                .catch((err) => {
                    this.$set(this.loadingbuttons, index, false);
                });
        },
        smsCancelRequest() {
            this.loadingButton = true;
            storeService.smsSchedulesCancel(this.storeId, this.smsSchedulesDetails.id).then(({ data }) => {
                this.loadingButton = false;
                this.$bvModal.hide('cancel-request-sms')
                this.$bvModal.hide('sms-schedules-detail')
                this.getSmsSchedules()
            })
        },
        getCompletionStatus() {
            this.loadingPage = true;
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                if (this.isAdminIdentityVerified) {
                    this.getSmsSchedules()
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getSmsSchedules() {
            this.loading = true
            this.loadingbuttons = []
            storeService.smsSchedules(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.requestList = data.items
                    if (this.requestList.length) {
                        this.requestList.forEach(obj => {
                            this.loadingbuttons.push(false)
                        });
                    }
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.requestList = data.items
                        if (this.requestList.length) {
                            this.requestList.forEach(obj => {
                                this.loadingbuttons.push(false)
                            });
                        }
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.currentDate = this.formatDate2(tomorrow);
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>